import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCog } from "@fortawesome/free-solid-svg-icons";
import { NavigationLink, NavigationContext } from "navigation-react";
import anihlogoimage from "./images/idclogo.png";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const DashboardContentHeader = () => {
  const { stateNavigator } = useContext(NavigationContext);
  const logoutToken = ls.get("userlogout_token");
  const username = ls.get("username"); 

  const handleLogout = async () => {
    fetch(`https://idcportal.salcommsystems.click/user/logout?_format=json&token=${logoutToken}`, {
        method: "POST",
        credentials: "include", // send session cookie
        headers: {
          "Content-Type": "application/json",
        },
    })
      .then(() => {
        ls.clear();
        stateNavigator.navigate("login");
      })
      .catch((error) => console.error("Logout error:", error));
  };

  return (
    <header className="top-menu">
      <div className="logo">
        <img src={anihlogoimage} alt="ANIH Logo" className="logo-image" />
        <h2>IDC Portal</h2>
      </div>
      <nav className="auth-links">
        <ul>
          <li>
            <NavigationLink
              stateKey="edituserprofile"
              navigationData={{ userdata: username }}
            >
              <FontAwesomeIcon icon={faUserCog} />
              {username}
            </NavigationLink>
          </li>
          <li>
            <a href="#logout" onClick={handleLogout}>
              Logout
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default DashboardContentHeader;
